module.exports = __webpack_public_path__ + "img/xcxqrcode.f08c047b.jpg";